module.exports = __webpack_public_path__ + "img/Clinics-Header-Image.2eb943bd.png";